/*
 * @Author: Liyafei
 * @Date: 2023-04-14 11:07:34
 * @Description:
 */
import request from '@/utils/request';

export function fetchVerification(data) {
  return request({
    url: '/adminapi/approval/record',
    method: 'post',
    data
  });
}

export function saveVerification(data) {
  return request({
    url: '/adminapi/approval/participant',
    method: 'post',
    data
  });
}
export function deleteApproval(data) {
  return request({
    url: '/adminapi/approval',
    method: 'delete',
    data
  });
}

export function postApprovalEditAuditor(data) {
  return request({
    url: '/adminapi/approval/edit/auditor',
    method: 'post',
    data
  });
}

export function verificationDetail(data) {
  return request({
    url: `/adminapi/approval/record/${data.approvalRecordId}`,
    method: 'get'
  });
}

export function verificationList(data) {
  return request({
    url: `/adminapi/approval/participant/${data.templateId}`,
    method: 'get'
  });
}

export function deleteVerification(data) {
  return request({
    url: '/adminapi/approval/participant/delete',
    method: 'post',
    data
  });
}

export function delApprovalAuditor(data) {
  return request({
    url: '/adminapi/approval/delete/auditor',
    method: 'delete',
    data
  });
}

export function verificationNum(data) {
  return request({
    url: '/adminapi/approval/auditing/num',
    method: 'get',
    params: data
  });
}

// 停用审批流前查询待审批数量
export function disableCheck(data) {
  return request({
    url: '/adminapi/approval/disable/check',
    method: 'get',
    params: data
  });
}

export function delApprovalLevel(data) {
  return request({
    url: '/adminapi/approval/delete/level',
    method: 'delete',
    data
  });
}
// 批量转移审批

export function postApprovalTransfer(data) {
  return request({
    url: '/adminapi/approval/transfer',
    method: 'post',
    data
  });
}

/**
 * @description: 我的审批-我收到的数据
 * @author 小小荧
 * @param {object} [params]
 * @return {Promise}
 * @date 2024-01-12 18:16
 */
export function postMyApprovalReceivedList(data) {
  return request({
    url: '/adminapi/approval/record/my/audit',
    data,
    method: 'post'
  });
}
/**
 * @description: 我的审批-我发起的数据
 * @author 小小荧
 * @param {object} [params]
 * @return {Promise}
 * @date 2024-01-12 18:16
 */
export function postMyApprovalInitiatedList(data) {
  return request({
    url: '/adminapi/approval/record/my/apply',
    data,
    method: 'post'
  });
}
export function getCardMakeUpDetails(params) {
  return request({
    url: '/adminapi/make-up',
    method: 'get',
    params
  });
}
/**
 * @description: 批量通过或者驳回
 * @author 小小荧
 * @param {object} [data]
 * @return {Promise}
 * @date 2024-01-15 15:11
 */
export function batchAudit(data) {
  return request({
    url: '/adminapi/approval/batch/audit',
    data,
    method: 'post'
  });
}
// 加签
export function postWorkflowAddSign(data) {
  return request({
    url: '/adminapi/workflow/add-sign',
    data,
    method: 'post'
  });
}
// 客户&机构审批详情的业务详情数据（7.15把直接展示业务信息改为了从表格点击跳转对应详情页）
export function getApprovalDetails(params) {
  return request({
    url: '/adminapi/approval/merge',
    method: 'get',
    params
  });
}

//获取当前用户设置的代理人
export function getAgentSettingByUid(params) {
  return request({
    url: '/adminapi/agentSetting/getByUid',
    method: 'get',
    params
  });
}

//保存or更新代理人
export function saveOrUpdateAgentSetting(data) {
  return request({
    url: '/adminapi/agentSetting/saveOrUpdate',
    method: 'post',
    data
  });
}

//待转移审批记录列表
export function getTransferrecord(data) {
  return request({
    url: '/adminapi/approval/transfer/record',
    method: 'post',
    data
  });
}
//批量转移审批
export function batchTransfer(data) {
  return request({
    url: '/adminapi/workflow/batch-transfer',
    method: 'post',
    data
  });
}

//批量转移审批，选择审批人列表
export function transferUserList(data) {
  return request({
    url: '/adminapi/workflow/transfer/userList',
    method: 'post',
    data
  });
}

// 新增常用审批意见
export function addApprovalOpinion(data) {
  return request({
    url: '/adminapi/approval/message/create',
    method: 'post',
    data
  });
}

// 删除常用审批意见
export function delApprovalOpinion(id) {
  return request({
    url: `/adminapi/approval/message/del/${id}`,
    method: 'delete'
  });
}

// 常用审批意见列表
export function getApprovalOpinionList(params) {
  return request({
    url: '/adminapi/approval/message/list',
    method: 'get',
    params
  });
}

// 获取审批相关动态表头 省区/架构
export function getApprovalDynamicHeader(params) {
  return request({
    url: '/adminapi/department-level/dynamicHeaders',
    method: 'get',
    params
  });
}

export function fetchVerificationRecord(data) {
  return request({
    url: '/adminapi/approval/verification/record',
    method: 'post',
    data
  });
}
